import * as React from 'react';

/**
 * What the parts of one vendor's page share (T-0207): the form open in
 * Sources, so the steps of the guide and the cards of To review can open
 * "Find pages" or "Add a web page" in place and scroll to it.
 */

export type SourceFormKind = 'web' | 'find' | 'upload' | 'link';

export interface VendorPageContextValue {
  form: SourceFormKind | null;
  openForm: (kind: SourceFormKind | null) => void;
}

const Ctx = React.createContext<VendorPageContextValue>({ form: null, openForm: () => undefined });

export function VendorPageProvider({
  value,
  children,
}: {
  value: VendorPageContextValue;
  children: React.ReactNode;
}) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useVendorPage(): VendorPageContextValue {
  return React.useContext(Ctx);
}
